import { EarningsOwnerType } from '@services/earnings/types/earnings-owner-type';
import { AdminGetStatementResponse } from '@services/royalties/types/api/admin-get-statements-response';
import AppState from '../state';
import Dinero from 'dinero.js';

export const getNextPayoutDate = (
  state: AppState,
  key: EarningsOwnerType
): Date | undefined => {
  const entries = state.earnings.eligibleEntries[key];

  if (!entries.length) {
    return;
  }

  const closest = entries.reduce((memo, e) => {
    const d = Number(e.eligibleDate);
    if (d < memo) {
      return d;
    }
    return memo;
  }, Number(entries[0].eligibleDate));

  return new Date(closest);
};

export const aggregateStatements = (statements: AdminGetStatementResponse, key: 'earnings' | 'streaming' | 'merch'): Dinero.Dinero => {
  return statements.reduce((acc, statement) => {
    return acc.add(Dinero(statement[key]));
  }, Dinero({ amount: 0, currency: 'USD', precision: 5 }));
}